import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Select, Select$ } from '@angular-redux3/store';
import { OverlayRef } from '@angular/cdk/overlay';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssoMediaEvent } from '../../store/entities';
import { overlayRefToken } from '../../utils';
import { slideInOut } from '../player.animations';

@Component({
  selector: 'mwo-mini-player',
  templateUrl: './mini-player.component.html',
  styleUrls: ['./mini-player.component.scss'],
  animations: [slideInOut]
})
export class MiniPlayerComponent implements OnInit {
  @ViewChild('miniPlayerContainer', { static: true }) miniPlayerContainer: ElementRef;
  @Select$(['player', 'media'], obs$ => obs$.pipe(map(media => ({ media, current: true, isWaitlist: false }))))
  currentMedia$: Observable<AssoMediaEvent>;
  @Select$(['player', 'waitList'], obs$ => obs$.pipe(map(waitlist => waitlist.map((media) => ({ media, isWaitlist: true })))))
  waitList$: Observable<AssoMediaEvent[]>;
  @Select('history') history$: Observable<AssoMediaEvent[]>;

  tracks$: Observable<AssoMediaEvent[]>;
  animationState: 'void' | 'enter' | 'leave' = 'void';
  readonly appPages = [
    { path: '/library', label: 'library', icon: 'library-icon' },
    { path: '/scheduler', label: 'planning', icon: 'scheduler-icon' },
    // {path: '/search', label: 'search', icon: 'search-icon'},
  ];

  constructor(
    @Inject(overlayRefToken) private overlayRef: OverlayRef,
  ) {
  }

  ngOnInit() {
    this.animationState = 'enter';
    this.tracks$ = combineLatest([this.currentMedia$, this.waitList$, this.history$]).pipe(
      map(([currentMedia, waitList, history]) => [...history.slice(0, 9).reverse(), currentMedia, ...waitList.slice(0, 9)]));
  }

  destroy() {
    this.animationState = 'leave';
    // So that the animation has time to run
    setTimeout(() => this.overlayRef.detach(), 400);
  }
}
